export class JwtStorage {
    static #jwtTokenKey = "jwt";
    static #jwtRefreshTokenKey = "jwtRefresh";
    static #claims = [];

    static get jwt() {
        return localStorage.getItem(this.#jwtTokenKey);
    }
    static set jwt(value) {
        if (value)
            this.#claims = this.#parseJwt(value);
        
        localStorage.setItem(this.#jwtTokenKey, value);
    }

    static get refreshToken() {
        return localStorage.getItem(this.#jwtRefreshTokenKey);
    }
    static set refreshToken(value) {
        localStorage.setItem(this.#jwtRefreshTokenKey, value);
    }

    static exists() {
        return this.jwt && this.jwt !== 'undefined' && this.jwt != 'undefined';
    }

    static getRefreshRequest() {
        return {
            token: this.jwt,
            refreshToken: this.refreshToken
        };
    }

    static clear() {
        localStorage.removeItem(this.#jwtTokenKey);
        localStorage.removeItem(this.#jwtRefreshTokenKey);
    }

    static getClaims() {
        return this.#claims;
    }

    static hasClaim(claim) {
        return this.getClaims().some(x => x.value === claim);
    }

    static hasAnyOfClaims(claims) {
        return claims?.some(x => this.hasClaim(x)) || true;
    }

    static #parseJwt (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    
        return Object.entries(JSON.parse(jsonPayload)).map((x) => ({key: x[0], value: x[1]})) ?? [];
    }

    static updateKeys(jwt, refresh) {
        // console.log(jwt, refresh);
        this.jwt = jwt;
        this.refreshToken = refresh;
    }
}
